import React, { useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./SignUp.css"; 
import { gsap } from "gsap"; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function SignUp() {
  const formRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useLayoutEffect(() => {
    document.title = "Sign-Up | Dandelion Run Community";
    gsap.fromTo(
      formRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
    );
  }, []);

  // --- STRONGER ANTI-SPAM PATTERN ---
  const urlBlockPattern = "((?!http|https|www|\\.com|\\.net|\\.org|\\.io|\\.ca|\\.co|\\.uk|\\.jpg|\\.png|\\.gif|\\.jpeg).)*";

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    
    setTimeout(() => {
      const didSucceed = Math.random() > 0.5;
      
      if (didSucceed) {
        toast.success("Application sent! Check your email soon.");
        setIsSubmitting(false);
        event.target.reset();
      } else {
        toast.error("Something went wrong. Please try again.");
        setIsSubmitting(false);
      }
    }, 2000);
  };

  return (
    <section className="signup-page-section">
      <ToastContainer position="bottom-right" autoClose={5000} theme="dark" />

      <div className="glass-form-container" ref={formRef}>
        
        <form onSubmit={handleSubmit}>
          <input type="hidden" name="form-name" value="signup" />

          <h2 className="signup-title">Join the Community</h2>

          {/* --- Honeypot Field --- */}
          <div className="honeypot-field">
            <label>Don’t fill this out if you're human:</label>
            <input name="bot-field" />
          </div>

          <div className="form-group">
            <label htmlFor="first-name">First Name</label>
            <input type="text" id="first-name" name="first-name" required />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            {/* Email field is SAFE (no pattern restriction) */}
            <input type="email" id="email" name="email" required />
          </div>

          <div className="form-group">
            <label className="gender-label">Gender</label>
            <div className="radio-group">
              <label className="radio-option">
                <input type="radio" name="gender" value="female" required />
                <span>Female</span>
              </label>
              <label className="radio-option">
                <input type="radio" name="gender" value="male" required />
                <span>Male</span>
              </label>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="reason">Reason for Joining</label>
            <textarea 
              id="reason" 
              name="reason" 
              rows="4" 
              required
              placeholder="Tell us why you want to run with us..."
              
              // --- RESTRICTED: Blocks Links & Images ---
              pattern={urlBlockPattern}
              title="Links, URLs, and image files are not allowed in the message."
            ></textarea>
          </div>

          <button 
            type="submit" 
            className="signup-submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <div className="loader"></div> 
                Sending...
              </>
            ) : (
              "Apply for Membership"
            )}
          </button>

          <div className="login-link-area">
            <p>
              Already have an account? 
              <Link to="/login"> Login here</Link>
            </p>
          </div>
          
        </form>
      </div>
    </section>
  );
}

export default SignUp;